import { render, staticRenderFns } from "./Uploads.vue?vue&type=template&id=6d71701e&scoped=true&"
import script from "./Uploads.vue?vue&type=script&lang=ts&"
export * from "./Uploads.vue?vue&type=script&lang=ts&"
import style0 from "./Uploads.vue?vue&type=style&index=0&id=6d71701e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d71701e",
  null
  
)

export default component.exports